import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { XIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDisabled?: boolean;
  cancelWording: string;
  confirmWording: string;
};

const ConfirmationDialog: FC<Props> = ({
  title,
  description,
  open,
  onClose,
  onConfirm,
  isDisabled,
  confirmWording,
  cancelWording,
}) => {
  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <div className="flex justify-between">
            <DialogTitle>{title}</DialogTitle>
            <XIcon className="cursor-pointer" onClick={() => onClose()} />
          </div>
        </DialogHeader>

        <DialogDescription>{description}</DialogDescription>

        <DialogFooter className="flex gap-[16px]">
          <Button
            className="w-[50%]"
            variant="secondaryFilled"
            onClick={() => onClose()}
          >
            {cancelWording}
          </Button>
          <Button
            className="w-[50%]"
            disabled={isDisabled}
            onClick={() => onConfirm()}
          >
            {confirmWording}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
